import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  components: { POIStep },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  created() {
    if (!this.editedItem.gastronomy) {
      this.$set(this.editedItem, "gastronomy", {
        seatsIndoors: undefined,
        seatsOutdoors: undefined
      });
    }
  },
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
